import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import circle from '../img/Tiers/Circles.svg';
import Seed from '../img/Tiers/seed.svg';
import Sapling from '../img/Tiers/sapling.svg';
import Tree from '../img/Tiers/tree.svg';
import MightyOak from '../img/Tiers/mighty-oak.svg';
import './Four_Tiers.scss';

export default function FourTiers() {
    return (
        <div className="tiers-container tier-circle d-flex" id="Allocation">
            <Container className="pad-tier" style={{ position: 'relative' }}>
                <div>
                    <div className="section-intro text-center mx-auto pad-b">
                        <h1 className="section-heading">
                            Allocation model - <span className="coustom-color">Tiered System</span>
                        </h1>
                    </div>
                    <Row className="tier-main-div">
                        <Col md={3} xs={12} className="tier-margin-bottom mb-md-0">
                            <div className="outline-btn outline-btn-1 tiers-card">
                                <Row className="mobile-view-padding">
                                    <Col
                                        xs={4}
                                        md={12}
                                        lg={12}
                                        className="text-center four-tier-img">
                                        <img src={Seed} alt="seed" className="hig-w" />
                                    </Col>
                                    <Col xs={8} md={12} lg={12}>
                                        <div className="text-center mobile-position">
                                            <h3 className="custom-font">Seed</h3>
                                        </div>
                                        <Row className="padding-style">
                                            <Col xs={6} md={6} className="border-right">
                                                <h4 className="text-pink custom-font">14%</h4>
                                                <p className="mb-0 card-footer-conent">Weightage</p>
                                            </Col>

                                            <Col xs={6} md={6}>
                                                <h4 className="text-green custom-font">5,000</h4>
                                                <p className="mb-0 card-footer-conent">
                                                    SOLR Staked
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={3} xs={12} className="tier-margin-bottom mb-md-0">
                            <div className="outline-btn outline-btn-1 tiers-card">
                                <Row className="mobile-view-padding">
                                    <Col
                                        xs={4}
                                        md={12}
                                        lg={12}
                                        className="text-center four-tier-img">
                                        <img src={Sapling} alt="sapling" className="hig-w" />
                                    </Col>
                                    <Col xs={8} md={12} lg={12}>
                                        <div className="text-center mobile-position">
                                            <h3 className="custom-font">Sapling</h3>
                                        </div>
                                        <Row className="padding-style">
                                            <Col xs={6} md={6} className="border-right">
                                                <h4 className="text-pink custom-font">21%</h4>
                                                <p className="mb-0 card-footer-conent">Weightage</p>
                                            </Col>

                                            <Col xs={6} md={6}>
                                                <h4 className="text-green custom-font">10,000</h4>
                                                <p className="mb-0 card-footer-conent">
                                                    SOLR Staked
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={3} xs={12} className="tier-margin-bottom mb-md-0">
                            <div className="outline-btn outline-btn-1 tiers-card">
                                <Row className="mobile-view-padding">
                                    <Col
                                        xs={4}
                                        md={12}
                                        lg={12}
                                        className="text-center four-tier-img">
                                        <img src={Tree} alt="tree" className="hig-w" />
                                    </Col>
                                    <Col xs={8} md={12} lg={12}>
                                        <div className="text-center mobile-position">
                                            <h3 className="custom-font">Tree</h3>
                                        </div>
                                        <Row className="padding-style">
                                            <Col xs={6} md={6} className="border-right">
                                                <h4 className="text-pink custom-font">29%</h4>
                                                <p className="mb-0 card-footer-conent">Weightage</p>
                                            </Col>

                                            <Col xs={6} md={6}>
                                                <h4 className="text-green custom-font">20,000</h4>
                                                <p className="mb-0 card-footer-conent">
                                                    SOLR Staked
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={3} xs={12} className="tier-margin-bottom mb-md-0">
                            <div className="outline-btn outline-btn-1 tiers-card">
                                <Row className="mobile-view-padding">
                                    <Col
                                        xs={4}
                                        md={12}
                                        lg={12}
                                        className="text-center four-tier-img">
                                        <img src={MightyOak} alt="mightyOak" className="hig-w" />
                                    </Col>
                                    <Col xs={8} md={12} lg={12}>
                                        <div className="text-center mobile-position">
                                            <h3 className="custom-font">Mighty Oak</h3>
                                        </div>
                                        <Row className="padding-style">
                                            <Col xs={6} md={6} className="border-right">
                                                <h4 className="text-pink custom-font">36%</h4>
                                                <p className="mb-0 card-footer-conent">Weightage</p>
                                            </Col>

                                            <Col xs={6} md={6}>
                                                <h4 className="text-green custom-font">40,000</h4>
                                                <p className="mb-0 card-footer-conent">
                                                    SOLR Staked
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="bg-cicle">
                    <img src={circle} alt="circle" />
                </div>
            </Container>
        </div>
    );
}
